import React, {forwardRef} from 'react'
import * as  styles from './Hamburger.module.scss'

const Hamburger = forwardRef(({ classes, ...otherProps},  ref) => (
        <button
            ref={ref}
            className={`${styles.hb_toggle} ${classes.join(' ')}`} 
            {...otherProps}>
            <div>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </button>
))

export default React.memo(Hamburger)